import { Route, Routes } from 'react-router-dom';

import { customerRoutes } from 'noddi-util';
import { BookingProposal } from './BookingProposal';
import { BookingProposalAddress } from './BookingProposal/Address';
import { BookingProposalConfirmation } from './BookingProposal/Confirmation';
import { BookingProposalTimeWindowPicker } from './BookingProposal/TimeWindowPicker';

export function BookingProposalRouter() {
  return (
    <Routes>
      <Route path={customerRoutes.bookingProposalLandingPage.getBasePath()} element={<BookingProposal />} />
      <Route path={customerRoutes.bookingProposalAddress.getBasePath()} element={<BookingProposalAddress />} />
      <Route
        path={customerRoutes.bookingProposalTimeWindowPicker.getBasePath()}
        element={<BookingProposalTimeWindowPicker />}
      />
      <Route
        path={customerRoutes.bookingProposalConfirmation.getBasePath()}
        element={<BookingProposalConfirmation />}
      />
    </Routes>
  );
}
